import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/company/logistics/:id',
  title: 'Editar Logística',
  endpoint: '/app/company',
}
